import { Address } from 'api/ApplicationApi';
import { AddressPartsType } from 'enums/AddressPartsType';

import { EMPTY_VALUE_SYMBOL } from './constants';

export interface GeoAttrs {
  streetAddress: string;
  city: string;
  state: string;
  zip: string;
  county: string;
}

export const getAddressParts = (addressComponents: google.maps.places.AddressComponent[]) => {
  return addressComponents.reduce(
    (acc, { types, longText, shortText }) => {
      if (types.includes(AddressPartsType.State) && shortText) {
        acc.state = shortText;
      }

      if (types.includes(AddressPartsType.Locality) && longText) {
        acc.city = longText;
      }

      if (types.includes(AddressPartsType.PostalCode) && shortText) {
        acc.zip = shortText;
      }

      if (types.includes(AddressPartsType.County) && shortText) {
        acc.county = shortText;
      }

      if (types.includes(AddressPartsType.StreetNumber) && longText) {
        acc.streetAddress = `${longText} ${acc.streetAddress}`;
      }

      if (types.includes(AddressPartsType.StreetName) && longText) {
        acc.streetAddress = `${acc.streetAddress} ${longText}`;
      }

      return acc;
    },
    { state: '', city: '', zip: '', streetAddress: '' } as GeoAttrs,
  );
};

export const createAddressStringFromObject = (address: Address | null | undefined): string => {
  if (!address) {
    return EMPTY_VALUE_SYMBOL;
  }

  const fullAddress = `${address.street_number || ''} ${address.street_name || ''} ${address.unit_number || ''}`;

  return fullAddress.trim().length ? fullAddress.trim() : EMPTY_VALUE_SYMBOL;
};

export const isPuertoRicoZipCode = (zipCode: string): boolean => {
  if (!zipCode) {
    return false;
  }

  const parsedZipCode = parseInt(zipCode);

  return (parsedZipCode >= 600 && parsedZipCode <= 799) || (parsedZipCode >= 900 && parsedZipCode <= 999);
};
